import { Font } from '@react-pdf/renderer';

// Import Montserrat font files as modules (Vite will handle these)
import MontserratRegular from '../../../theme/fonts/Montserrat/Montserrat-Regular.ttf?url';
import MontserratItalic from '../../../theme/fonts/Montserrat/Montserrat-Italic.ttf?url';
import MontserratMedium from '../../../theme/fonts/Montserrat/Montserrat-Medium.ttf?url';
import MontserratMediumItalic from '../../../theme/fonts/Montserrat/Montserrat-MediumItalic.ttf?url';
import MontserratSemiBold from '../../../theme/fonts/Montserrat/Montserrat-SemiBold.ttf?url';
import MontserratSemiBoldItalic from '../../../theme/fonts/Montserrat/Montserrat-SemiBoldItalic.ttf?url';
import MontserratBold from '../../../theme/fonts/Montserrat/Montserrat-Bold.ttf?url';
import MontserratBoldItalic from '../../../theme/fonts/Montserrat/Montserrat-BoldItalic.ttf?url';
import MontserratLight from '../../../theme/fonts/Montserrat/Montserrat-Light.ttf?url';
import MontserratLightItalic from '../../../theme/fonts/Montserrat/Montserrat-LightItalic.ttf?url';

/**
 * PDF Font Registration
 * 
 * Registers custom fonts for use in PDF generation.
 * This ensures PDFs use the same Montserrat font family as the main application.
 */

// Register Montserrat font family with different weights and styles
Font.register({
  family: 'Montserrat',
  fonts: [
    {
      src: MontserratRegular,
      fontWeight: 400,
      fontStyle: 'normal',
    },
    {
      src: MontserratItalic,
      fontWeight: 400,
      fontStyle: 'italic',
    },
    {
      src: MontserratMedium,
      fontWeight: 500,
      fontStyle: 'normal',
    },
    {
      src: MontserratMediumItalic,
      fontWeight: 500,
      fontStyle: 'italic',
    },
    {
      src: MontserratSemiBold,
      fontWeight: 600,
      fontStyle: 'normal',
    },
    {
      src: MontserratSemiBoldItalic,
      fontWeight: 600,
      fontStyle: 'italic',
    },
    {
      src: MontserratBold,
      fontWeight: 700,
      fontStyle: 'normal',
    },
    {
      src: MontserratBoldItalic,
      fontWeight: 700,
      fontStyle: 'italic',
    },
    {
      src: MontserratLight,
      fontWeight: 300,
      fontStyle: 'normal',
    },
    {
      src: MontserratLightItalic,
      fontWeight: 300,
      fontStyle: 'italic',
    },
  ],
});

// Export font names for easy reference
export const PDF_FONTS = {
  PRIMARY: 'Montserrat',
  FALLBACK: 'Helvetica',
} as const;

